<template>
    <ContentComp
        :show-as-modal="true"
        class="p-0"
    >
        <div
            class="d-flex flex-column flex-nowrap gap-3 ms-3"
            v-for="rc in contestant.RaceContestants"
            :key="rc.ID"
        >
            <div class="flex-grow-1">
                <h5>{{ Races.find((x) => x.ID == rc.RaceID)?.Name }}</h5>
                <ul class="p-0">
                    <li
                        v-for="category in Categories"
                        :key="category.ID"
                    >
                        <div class="form-check">
                            <label class="text-nowrap form-check-label w-100"
                                >{{ category.Name }}
                                <input
                                    ref="inputref"
                                    class="ag-input-field-input ag-checkbox-input form-check-input"
                                    type="checkbox"
                                    :checked="isChecked(rc.ID, category.ID)"
                                    @change="setRankingCategory($event, rc, category.ID)"
                                />
                            </label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </ContentComp>
</template>

<script setup lang="ts">
import { ContentComp } from '@/components';
import { RankingCategory, type RaceContestant, type RaceContestantDetails } from '@/objects/generated';
import { useEventCommonStoreRef } from '@/stores';

const contestant = defineModel<RaceContestantDetails>({ required: true });

const { Categories, Races } = useEventCommonStoreRef();

/**
 * Check if the checkbox should be checked or not
 * @param raceContestantId
 * @param categoryId
 */
const isChecked = (raceContestantId: number, categoryId: number) =>
    contestant.value.RaceContestants.find((rc) => rc.ID == raceContestantId)?.RankingCategories.some(
        (x) => x.EntityState != 'Deleted' && x.RaceContestantID == raceContestantId && x.CategoryID == categoryId,
    ) ?? false;

/**
 * We update or sets a new ranking category
 * @param raceContestant
 * @param categoryId
 */
const setRankingCategory = (event: Event, raceContestant: RaceContestant, categoryId: number) => {
    let rcat = raceContestant.RankingCategories.find((x) => x.RaceContestantID == raceContestant.ID && x.CategoryID == categoryId);
    let isChecked = (event.target as HTMLInputElement).checked;

    if (rcat) {
        // if it is added we remove it or else we change the state
        if (rcat.EntityState == 'Added') {
            // Fuck, her skriver vi til RankingCategories.
            // Det her gjør mening å gjøre, fordi vi skipper slett greia
            // Så vi må ha mulighet for å filtrere vekk jævlene.
            // Kanskje vi skulle lagt til det som en mulighet på greia
            // Da må vi ha getter og setter. Problemet her er at man kan gjøre hva faen man vil da
            // Det her betyr jo da at vi ikke kan ha greiene readonly
            // Og da må vi ha en getter og setter på det.
            // Settern kan validere at vi ikke har gjort noe funky, men det er kanskje heller ikke nødvendig
            raceContestant.RankingCategories = raceContestant.RankingCategories.filter((x) => x != rcat);
        } else {
            if (!isChecked) {
                rcat.Delete();
            } else {
                rcat.DeleteUndo();
            }
        }
    } else {
        rcat = RankingCategory.FromJsValues({
            EntityState: 'Added',
            RaceContestantID: raceContestant.ID,
            CategoryID: categoryId,
        });
        raceContestant.RankingCategories.push(rcat);
    }
};
</script>
